import MisOfertas from '../components/mercado/MisOfertas';

const Ofertas = () => <MisOfertas />;

export default Ofertas;
